module.exports = __webpack_public_path__ + "img/position_between_line.68b77ae8.svg";